import { Controller } from "@hotwired/stimulus"
import IMask from 'imask'

export default class extends Controller {
  static targets = ['input']

  connect() {
    this.initializeMask()
  }

  initializeMask() {
    this.mask = IMask(this.inputTarget, {
      mask: '(000) 000-0000',
      lazy: false,
      overwrite: 'shift'
    })

    this.createHiddenInput()

    this.mask.on('accept', () => {
      if (this.hiddenInput) {
        this.hiddenInput.value = this.mask.unmaskedValue
      }
    })
  }

  createHiddenInput() {
    const hiddenInputId = `${this.inputTarget.id}_hidden`
    const existingHidden = this.element.querySelector(`#${hiddenInputId}`)
    if (existingHidden) {
      existingHidden.remove()
    }

    this.hiddenInput = document.createElement('input')
    this.hiddenInput.type = 'hidden'
    this.hiddenInput.id = hiddenInputId
    this.hiddenInput.name = this.inputTarget.name

    this.hiddenInput.value = this.mask.unmaskedValue

    this.inputTarget.name = `${this.inputTarget.name.replace(/_display.*$/, '')}_display`

    this.inputTarget.parentNode.appendChild(this.hiddenInput)
  }
}
